/**
 * Script de verificación de GTM
 * Ejecutar en la consola del navegador para verificar el estado de GTM
 */

window.verifyGTM = function() {
  console.clear();
  console.log('🔍 Iniciando verificación de GTM...\n');
  
  // Verificar que GTM esté disponible
  if (!window.gtmService) {
    console.error('❌ GTM Service no está disponible');
    return;
  }
  
  // Ejecutar diagnóstico completo
  window.gtmService.runDiagnostics();
  
  // Verificaciones adicionales
  console.group('🔧 Verificaciones Adicionales');
  
  // Verificar DataLayer
  if (window.dataLayer) {
    console.log('✅ DataLayer existe con', window.dataLayer.length, 'elementos');
    console.log('📋 Contenido del DataLayer:', window.dataLayer);
  } else {
    console.log('❌ DataLayer no existe');
  }
  
  // Verificar función gtag
  if (typeof window.gtag === 'function') {
    console.log('✅ Función gtag está disponible');
  } else {
    console.log('❌ Función gtag no está disponible');
  }
  
  // Verificar script GTM en el DOM
  const gtmScripts = document.querySelectorAll('script[src*="googletagmanager.com"]');
  if (gtmScripts.length > 0) {
    console.log('✅ Script GTM encontrado en el DOM');
    gtmScripts.forEach((script, index) => {
      console.log(`   Script ${index + 1}:`, script.src);
    });
  } else {
    console.log('❌ Script GTM no encontrado en el DOM');
  }
  
  console.groupEnd();
  
  // Enviar evento de prueba
  console.log('\n🧪 Enviando evento de prueba...');
  window.gtmService.sendTestEvent();
  
  console.log('\n✅ Verificación completada. Revisa los logs anteriores para más detalles.');
};

// Función para copiar información de diagnóstico
window.copyGTMInfo = function() {
  if (!window.gtmService) {
    console.error('❌ GTM Service no está disponible');
    return;
  }
  
  const info = window.gtmService.getGTMDiagnosticInfo();
  const infoText = JSON.stringify(info, null, 2);
  
  navigator.clipboard.writeText(infoText).then(() => {
    console.log('📋 Información GTM copiada al portapapeles');
  }).catch(err => {
    console.error('❌ Error al copiar:', err);
    console.log('📋 Información GTM:', infoText);
  });
};

// Mostrar instrucciones
console.log('🚀 Scripts de verificación GTM cargados:');
console.log('   - verifyGTM() - Ejecuta verificación completa');
console.log('   - copyGTMInfo() - Copia información de diagnóstico');
console.log('   - Ctrl+Shift+G - Abrir panel visual de diagnóstico'); 